import type { ValidationResult } from './types';

const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
const phonePattern = /^\+?[0-9\s().-]{8,20}$/;
const vietnamPhonePattern = /^(?:0?\d{9}|0?\d{10}|84\d{9}|84\d{10})$/;

export function validateEmail(value: string): ValidationResult {
  const trimmed = value.trim();

  if (!trimmed) {
    return { valid: false, message: 'Email is required.' };
  }

  if (!emailPattern.test(trimmed)) {
    return { valid: false, message: 'Enter a valid email address.' };
  }

  return { valid: true };
}

export function validatePhone(value: string): ValidationResult {
  const trimmed = value.trim();

  if (!trimmed) {
    return { valid: false, message: 'Phone number is required.' };
  }

  if (!phonePattern.test(trimmed)) {
    return { valid: false, message: 'Enter a valid phone number.' };
  }

  const digits = trimmed.replace(/\D/g, '');
  if (digits.length < 8 || digits.length > 15) {
    return { valid: false, message: 'Phone number must be 8 to 15 digits.' };
  }

  return { valid: true };
}

export function normalizePhone(value: string): string {
  return value.trim().replace(/[^\d+]/g, '');
}

export function validateVietnamPhone(value: string): ValidationResult {
  const digits = value.replace(/\D/g, '');

  if (!digits) {
    return { valid: false, message: 'Phone number is required.' };
  }

  if (!vietnamPhonePattern.test(digits)) {
    return { valid: false, message: 'Enter a valid Vietnam phone number.' };
  }

  return { valid: true };
}

export function normalizeVietnamPhone(value: string): string {
  let digits = value.replace(/\D/g, '');

  if (digits.startsWith('84')) {
    digits = digits.slice(2);
  }

  if (digits.startsWith('0')) {
    digits = digits.slice(1);
  }

  return `+84${digits}`;
}
